import { PAYMENT_METHOD_OPTION_HEIGHT } from './constants';

export const baseLinkCss = {
  width: 'full',
  height: PAYMENT_METHOD_OPTION_HEIGHT,
  backgroundColor: 'transparent',
};
